
















































import {Vue, Component, Prop} from 'vue-property-decorator'
import {TokensTableItem} from '@/model/resource/TokensTableItem'
import SwapLockedAmount from '@/components/SwapLockedAmount.vue'

@Component({
  components: {SwapLockedAmount},
})
export default class SwapTokenDetails extends Vue {
  @Prop({type: String, required: true}) title!: string
  @Prop({type: Boolean, default: true, required: false})
  centralizedTitle!: boolean
  @Prop({type: TokensTableItem, required: true}) token!: TokensTableItem
  @Prop({type: String, required: true}) amount!: string
  @Prop({type: String, required: true}) amountInDollar!: string
  @Prop({type: String, required: true}) bgColor!: string
  @Prop({type: String, required: false, default: 'text-slate-blue'})
  customTitleClass!: string

  get amountFormatted() {
    if (!this.amount) {
      return '0.00'
    }

    if (this.amount.endsWith('.')) {
      return this.amount.slice(0, -1)
    } else {
      return this.amount
    }
  }

  get titleClass() {
    let adicionalClass

    if (this.centralizedTitle) {
      adicionalClass = 'text-center sm:text-left'
    } else {
      adicionalClass = 'text-left'
    }

    return `${this.customTitleClass} ${adicionalClass}`
  }

  get tokenImageAlt() {
    return `${this.token.symbol} icon`
  }
}
